import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MainButton from "../../components/common/MainButton/MainButton";
// import VerificationPopUp from "../VerificationPop/VerificationPopUp";
import { useState } from "react";
import Paragraph from "../../components/common/Typography/Paragraph";
import useClickOutside from "../../Hooks/useClickOutside";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";
import { SPECIALTY_CHIP_CLASS } from "../../components/common/Profile/ProfileSpecialtyChips";
import SpecialText from "../../components/common/Typography/SpecialText";
import { Rating } from "primereact/rating";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from 'swiper/modules';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import Lightbox from "../../components/common/Lightbox/Lightbox";
import { FaRegThumbsUp, FaRegThumbsDown } from "react-icons/fa";
import { BiLike, BiDislike } from "react-icons/bi";
import {
  PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS,
  PUBLIC_CONTENT_TO_CTA_CLASS,
} from "../Public/shared/publicLayoutSpec";

const PosterReviews = ({ showMeReply, showMeReport, DropdownClasses, starFilter, onClearFilter }) => {
  const navigate = useNavigate();
  const [ShowCrossButton, setShowCrossButton] = useState(true);
  const [filters, setFilters] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, () => {
    setFilters(false);
  });
  const [reply, setReply] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  
  // Pagination state
  const [visibleReviewsCount, setVisibleReviewsCount] = useState(4);
  const reviewsPerPage = 4;

  // State for helpful votes for each review
  const [helpfulVotes, setHelpfulVotes] = useState({
    0: { up: 0, down: 0, userVote: null },
    1: { up: 0, down: 0, userVote: null },
    2: { up: 0, down: 0, userVote: null },
    3: { up: 0, down: 0, userVote: null },
    4: { up: 0, down: 0, userVote: null },
    5: { up: 0, down: 0, userVote: null },
    6: { up: 0, down: 0, userVote: null },
    7: { up: 0, down: 0, userVote: null },
    8: { up: 0, down: 0, userVote: null },
    9: { up: 0, down: 0, userVote: null },
  });

  const reviewImages = [
    require("../../assets/img/default-image.jpg"),
    require("../../assets/img/default-image.jpg"),
    require("../../assets/img/default-image.jpg"),
  ];

  // All reviews data with different star ratings
  const allReviews = [
    {
      id: 1,
      name: "Jozeph J",
      location: "Duffy, Australian Capital Territory, 2611",
      rating: 5,
      text: "Donec consequat, lacus vel ornare laoreet, nibh lacus blandit est, venenatis feugiat augue augue eu ipsum. a b c Vestibulum pulvinar eleifend facilisis. Aliquam a tempor orci, vitae ullamcorper mauris.",
      timeAgo: "1 hour ago",
      // hasImages: true,
      tags: ["Plumbing", "Emergency", "24/7 Service"]
    },
    {
      id: 2,
      name: "Sarah M",
      location: "Duffy, Australian Capital Territory, 2611",
      rating: 4,
      text: "Vestibulum pulvinar eleifend facilisis. Aliquam a tempor orci, vitae ullamcorper mauris. Cras sollicitudin turpis quis tempus pretium. Maecenas vehicula mauris sagittis justo blandit.",
      timeAgo: "2 hours ago",
      hasImages: false,
      tags: ["Electrical", "Installation", "Safety Check"]
    },
    {
      id: 3,
      name: "Michael R",
      location: "Duffy, Australian Capital Territory, 2611",
      rating: 3,
      text: "Cras sollicitudin turpis quis tempus pretium. Maecenas vehicula mauris sagittis justo blandit, sed consequat lacus dictum. Sed molestie diam neque, ut consectetur dui iaculis vitae.",
      timeAgo: "3 hours ago",
      hasImages: false,
      tags: ["Carpentry", "Repair", "Custom Work"]
    },
    {
      id: 4,
      name: "Emma L",
      location: "Canberra, Australian Capital Territory, 2600",
      rating: 5,
      text: "Exceptional service! The team went above and beyond my expectations. Professional, punctual, and the quality of work was outstanding. Highly recommend to anyone looking for reliable service.",
      timeAgo: "5 hours ago",
      hasImages: true,
      tags: ["Painting", "Interior", "Premium Finish"]
    },
    {
      id: 5,
      name: "David K",
      location: "Belconnen, Australian Capital Territory, 2617",
      rating: 4,
      text: "Very good experience overall. The work was completed on time and the communication was clear throughout the process. Would definitely use their services again.",
      timeAgo: "1 day ago",
      hasImages: false,
      tags: ["Landscaping", "Design", "Maintenance"]
    },
    {
      id: 6,
      name: "Lisa P",
      location: "Woden, Australian Capital Territory, 2606",
      rating: 2,
      text: "The service was okay but not great. There were some delays and the final result wasn't exactly what I expected. Communication could have been better.",
      timeAgo: "2 days ago",
      hasImages: false,
      tags: ["Cleaning", "Regular", "Deep Clean"]
    },
    {
      id: 7,
      name: "John S",
      location: "Tuggeranong, Australian Capital Territory, 2900",
      rating: 5,
      text: "Absolutely fantastic! The attention to detail was incredible and the team was so professional. The end result exceeded all my expectations. Thank you!",
      timeAgo: "3 days ago",
      hasImages: true,
      tags: ["Roofing", "Repair", "Emergency"]
    },
    {
      id: 8,
      name: "Maria G",
      location: "Gungahlin, Australian Capital Territory, 2912",
      rating: 1,
      text: "Very disappointed with the service. Poor communication, delays, and the quality was not up to standard. Would not recommend.",
      timeAgo: "4 days ago",
      hasImages: false,
      tags: ["HVAC", "Installation", "Service"]
    },
    {
      id: 9,
      name: "Robert T",
      location: "Fyshwick, Australian Capital Territory, 2609",
      rating: 4,
      text: "Good quality work and reasonable pricing. The team was friendly and professional. Minor delays but overall satisfied with the result.",
      timeAgo: "5 days ago",
      hasImages: false,
      tags: ["Flooring", "Installation", "Hardwood"]
    },
    {
      id: 10,
      name: "Anna W",
      location: "Braddon, Australian Capital Territory, 2612",
      rating: 3,
      text: "Average experience. The work was completed but there were some issues that needed to be addressed. Service was okay but could be improved.",
      timeAgo: "1 week ago",
      hasImages: false,
      tags: ["Tiling", "Bathroom", "Kitchen"]
    },
  ];

  // Filter reviews based on starFilter
  const filteredReviews = starFilter 
    ? allReviews.filter(review => review.rating === starFilter)
    : allReviews;

  // Get visible reviews based on pagination
  const visibleReviews = filteredReviews.slice(0, visibleReviewsCount);
  const hasMoreReviews = visibleReviewsCount < filteredReviews.length;

  useEffect(() => {
    if (reply) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [reply]);

  // Reset visible reviews count when filter changes
  useEffect(() => {
    setVisibleReviewsCount(4);
  }, [starFilter]);

  const handleImageClick = (idx) => {
    setImageIndex(idx);
    setShowPreview(true);
  };

  const handleHelpfulVote = (reviewIndex, voteType) => {
    setHelpfulVotes(prev => {
      const currentReview = prev[reviewIndex];
      const newVote = currentReview.userVote === voteType ? null : voteType;
      
      let newUp = currentReview.up;
      let newDown = currentReview.down;
      
      // Remove previous vote if exists
      if (currentReview.userVote === 'up') newUp--;
      if (currentReview.userVote === 'down') newDown--;
      
      // Add new vote
      if (newVote === 'up') newUp++;
      if (newVote === 'down') newDown++;
      
      return {
        ...prev,
        [reviewIndex]: {
          up: newUp,
          down: newDown,
          userVote: newVote
        }
      };
    });
  };

  const handleLoadMore = () => {
    setVisibleReviewsCount(prev => prev + reviewsPerPage);
  };

  const handleTagClick = () => {
    navigate('/category/plumbing');
  };

  return (
    <>
      <div className="max-w-full md:max-w-full xl:max-w-full 2xl:max-w-full text-offblack rounded-3xl">
        <div className="flex justify-between items-center" ref={ref}>
            <div className="flex items-center gap-2">
                              {/* {starFilter && (
                  <MainButton
                    variant="outlinesmallbetween"
                    onClick={onClearFilter}
                    className="!w-auto"
                  >
                    <span className="flex items-center">Showing {starFilter}-star reviews</span>
                    <i className="fi fi-rs-cross text-[14px] flex items-center justify-center ml-6"></i>
                  </MainButton>
                )} */}
            </div>
          <div className="relative w-fit">
            {/* <MainButton
              variant={"smallbetween"}
              onClick={() => setFilters(!filters)}
            >
              Latest
              <i
                className={
                  filters
                    ? "fi fi-rs-angle-up text-[14px] lg:text-sm cursor-pointer flex items-center"
                    : "fi fi-rs-angle-down text-[14px] lg:text-sm cursor-pointer flex items-center"
                }
              ></i>
            </MainButton> */}

            {filters && (
              <div
                className={`flex flex-col rounded-xl w-[150px] sm:w-[150px] md:w-[150px] h-auto gap-3 absolute z-10 mt-3 text-offblack py-5 px-3 ${DropdownClasses} right-0`}
              >
                <button onClick={() => setFilters(false)}>
                  <AuxiliaryText
                    variant={"MenuDropdown"}
                    className={"text-offblack hover:text-primaryblue"}
                  >
                    Lowest
                  </AuxiliaryText>
                </button>
                <button onClick={() => setFilters(false)}>
                  <AuxiliaryText
                    variant={"MenuDropdown"}
                    className={"text-offblack hover:text-primaryblue"}
                  >
                    Highest
                  </AuxiliaryText>
                </button>
                <button onClick={() => setFilters(false)}>
                  <AuxiliaryText
                    variant={"MenuDropdown"}
                    className={"text-offblack hover:text-primaryblue"}
                  >
                    Earliest
                  </AuxiliaryText>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Reviews List */}
        {visibleReviews.length > 0 ? (
          <div className="grid grid-cols-1">
            {visibleReviews.map((review, index) => (
              <div
                key={review.id}
                className={`${
                  index > 0 ? PUBLIC_HEADING_TO_CONTENT_COMPACT_CLASS : ""
                } ${
                  index < visibleReviews.length - 1
                    ? "border-b border-b-mediumgray pb-8"
                    : ""
                }`}
              >
              <div className="flex gap-x-3">
                <div className="w-10 sm:w-12 shrink-0">
                  <img
                    className="avatar-small object-cover"
                    src={require("../../assets/img/User.png")}
                    alt={"no"}
                  />
                </div>
                <div className="mt-1 w-full">
                  <SpecialText variant={"ProfileName"} className={"text-offblack"}>
                    {review.name}
                  </SpecialText>
                  <div className="mt-1">
                    <SpecialText
                      variant="ProfileMicro"
                      className={"text-start text-offblack"}
                    >
                      {review.location}
                    </SpecialText>
                  </div>
                  
                  <div className="mt-2">
                    <Paragraph variant={"MainParagraph"}>
                      {review.text}
                    </Paragraph>

                    {/* Review Tags - Show after text for all reviews */}
                    {review.tags && review.tags.length > 0 && (
                      <div className="mt-3 flex flex-wrap items-center gap-2">
                          {review.tags.map((tag, tagIndex) => (
                            <button
                              key={tagIndex}
                              type="button"
                              onClick={handleTagClick}
                              className={`${SPECIALTY_CHIP_CLASS} cursor-pointer`}
                            >
                              <AuxiliaryText
                                variant="CtaChip"
                                className="text-offblack group-hover:text-white"
                              >
                                {tag}
                              </AuxiliaryText>
                            </button>
                          ))}
                      </div>
                    )}

                    {/* Review Images */}
                    {review.hasImages && (
                      <div className="grid grid-cols-5 gap-4 mt-4 mb-4">
                        {reviewImages.map((image, imgIndex) => (
                          <div key={imgIndex} className="aspect-[150/100] cursor-pointer" onClick={() => handleImageClick(imgIndex)}>
                            <img
                              src={image}
                              alt={`Review image ${imgIndex + 1}`}
                              className="w-full h-full object-cover rounded-lg"
                            />
                          </div>
                        ))}
                      </div>
                    )}

                    {showPreview && (
                      <Lightbox
                        images={reviewImages}
                        initialIndex={imageIndex}
                        onClose={() => setShowPreview(false)}
                      />
                    )}
                    
                    <div className="flex items-center gap-2 mt-4">
                      <div className="flex items-center">
                        <Rating
                          value={review.rating}
                          stars={1}
                          style={{ gap: 5 }}
                          cancel={false}
                          defaultValue={review.rating}
                        />
                        <SpecialText
                          variant={"Counter"}
                          className={"ml-1 text-offblack"}
                        >
                          {review.rating.toFixed(1)}
                        </SpecialText>
                      </div>
                      <div className="mx-2">
                        <i className="fi fi-ss-bullet text-[10px] text-offblack"></i>
                      </div>
                      <div>
                        <SpecialText
                          variant={"Counter"}
                          className={"text-offblack"}
                        >
                          {review.timeAgo}
                        </SpecialText>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-10">
            <SpecialText variant={"Counter"} className="text-gray-500">
              No reviews found for {starFilter}-star rating
            </SpecialText>
          </div>
        )}

        {/* Load More Button */}
        {hasMoreReviews && (
          <div className={`flex justify-center ${PUBLIC_CONTENT_TO_CTA_CLASS}`}>
            <MainButton
              variant="outlinemedium"
              onClick={handleLoadMore}
              className="px-8 py-3"
            >
              Load More
            </MainButton>
          </div>
        )}
      </div>
    </>
  );
};

export default PosterReviews;
